var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49992 2.08398C5.23223 2.08398 2.58325 4.73297 2.58325 8.00065C2.58325 11.2683 5.23223 13.9173 8.49992 13.9173C11.7676 13.9173 14.4166 11.2683 14.4166 8.00065C14.4166 4.73297 11.7676 2.08398 8.49992 2.08398ZM1.08325 8.00065C1.08325 3.90454 4.40381 0.583984 8.49992 0.583984C12.596 0.583984 15.9166 3.90454 15.9166 8.00065C15.9166 12.0968 12.596 15.4173 8.49992 15.4173C4.40381 15.4173 1.08325 12.0968 1.08325 8.00065Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25671 5.33398C9.25671 5.7482 8.92093 6.08398 8.50671 6.08398H8.50005C8.08583 6.08398 7.75005 5.7482 7.75005 5.33398C7.75005 4.91977 8.08583 4.58398 8.50005 4.58398H8.50671C8.92093 4.58398 9.25671 4.91977 9.25671 5.33398Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50671 11.418C8.0925 11.418 7.75671 11.0822 7.75671 10.668V8.0013C7.75671 7.58709 8.0925 7.2513 8.50671 7.2513C8.92093 7.2513 9.25671 7.58709 9.25671 8.0013V10.668C9.25671 11.0822 8.92093 11.418 8.50671 11.418Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo2);
export default __webpack_public_path__ + "static/media/info-2.d11ad224a151f5103d3e07b8e8b75fe1.svg";
export { ForwardRef as ReactComponent };